import React, { useState } from 'react'
import styles from '../SliderCard.module.css'
import { useNavigate } from 'react-router-dom'

const choosePath = (category,slug) => {
    if(category=="Case Studies"){
      return `/case-studies/${slug}`
    }
    if(category=="Products and Services"){
      return `/pages/${slug}`
    }
    if(category=="Reviews & Blogs"){
      return `/pages/${slug}`
    }
  
  }

function ReadMore({item, text}) {

    const [arrowChange, setArrowChange] = useState(false);
    const navigate = useNavigate();
    

  return (
    <div
          className={styles.readMore}
          onMouseEnter={() => setArrowChange(true)}
          onMouseLeave={() => setArrowChange(false)}
          onClick={() => {
            if(text == "Reach Us"){
                navigate('/contact-us')
            }else{
            const path = choosePath(item?.categoryName, item?.slug);
            navigate(path);
            }
          }}
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <h4>{text}</h4>
          <img
            src={
              arrowChange
                ? "/img/bodyshop/black-blue-arrow.svg"
                : "/img/bodyshop/right-arrow-white.svg"
            }
          />
        </div>
  )
}

export default ReadMore
